import { TPromptPromiseResponse } from '../../../types';
import { executionFloatingChatController } from '../../..';
import { generateConfirmedValues } from './generateConfirmedValues';
import { getFormsAssistantConfiguration } from '../../../getFormsAssistantConfiguration';
import { ChatMessage, TMessageType } from '@apia/ai';
import { TFieldValue } from './resolveResponseResult';

export const resolveFinalMessage = (
  form: {
    message: string;
    filledFormsMap: Record<string, Record<string, TFieldValue>>;
    type: TMessageType;
  },
  confirmedValues: string[],
) => {
  const formsAssistantConfigurations = getFormsAssistantConfiguration();
  for (const [key, value] of Object.entries(form.filledFormsMap ?? {})) {
    if (
      key.toLocaleLowerCase() ===
        formsAssistantConfigurations.OBSERVATIONS.name.toLowerCase() &&
      String(value) ===
        formsAssistantConfigurations.OBSERVATIONS.name.toLowerCase()
    )
      continue;
    if (value) {
      break;
    }
  }
  const token = '-_-_-TOK-_-_-';
  if (
    !form.message.includes(token) ||
    (form.message.includes(token) && confirmedValues.length !== 0)
  ) {
    const message: TPromptPromiseResponse = {
      message:
        confirmedValues.length !== 0
          ? form.message.replace(
              token,
              generateConfirmedValues(confirmedValues),
            )
          : form.message,
      messageType: form.type,
    };
    executionFloatingChatController.addMessage(
      new ChatMessage(
        message.message
          .replace(/([^\n])(\s*)^(#+\s)/gm, '$1\n$3')
          .replace(/^#{1,6}(?=\s)/gm, (match) => {
            return match.length < 6 ? '#'.repeat(match.length + 1) : match;
          }),
        message.messageType as TMessageType,
      ),
    );
  }
};
